// eslint-disable-next-line @typescript-eslint/no-unused-vars
/* eslint-disable @typescript-eslint/no-explicit-any */
import { GET_INFO_CUSTOMER, GET_INFO_CUSTOMER_DONE, REQUEST_OTP_NEW_PHONE, REQUEST_OTP_PHONE_EXIST, UPDATE_INFO_CUSTOMER, VERIFY_OTP_PHONE } from "./constant";

export const GetInfoCustomer = (payload?: any, callback?: CallBackActionITF) => {
  return {
    type: GET_INFO_CUSTOMER,
    payload,
    callback
  };
};

export const GetInfoCustomerDone = (data: any) => ({
  type: GET_INFO_CUSTOMER_DONE,
  payload: data
})

export const RequestOtpPhoneExist = (payload?: any, callback?: CallBackActionITF) => {
  return {
    type: REQUEST_OTP_PHONE_EXIST,
    payload,
    callback
  };
};

export const RequestOtpNewPhone = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: REQUEST_OTP_NEW_PHONE,
    payload,
    callback
  };
};

export const VerifyOtpPhone = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: VERIFY_OTP_PHONE,
    payload,
    callback
  };
};

export const UpdateInfoCustomer = (payload: any, callback?: CallBackActionITF) => {
  return {
    type: UPDATE_INFO_CUSTOMER,
    payload,
    callback
  };
};